import React from 'react';
import PropTypes from 'prop-types';
import { SummaryTable } from 'Components';
import './OverviewDesktop.css';

const OverviewDesktop = ({
  placeholderDescription,
  templatesData,
  jobsData,
  ordersData,
  invoicesData,
  InvoiceDescription,
  rowRules,
  menuOptions,
  powerTableViewCode,
  powerTableIndex,
  isSupplyWarningON,
  isTemplateWarningON,
  isSubmissionWarningON,
  ...rest
}) => {
  //! To remove the multi delete option from the popover menu in overviewDesktop
  const modifiedMenuOptions = menuOptions.filter(option => option.code !== "multiDelete")

  return (
  <div className="overview__desktop">
    <SummaryTable
      description={placeholderDescription('template', '/templates/new')}
      rowRules={rowRules.template}
      menuOptions={modifiedMenuOptions}
      powerTableIndex={powerTableViewCode === 'overviewTemplates' ? powerTableIndex : null}
      isSupplyWarningON={isSupplyWarningON}
      isTemplateWarningON={isTemplateWarningON}
      isSubmissionWarningON={isSubmissionWarningON}
      {...templatesData}
      {...rest}
    />
    <SummaryTable
      description={placeholderDescription('job', '/jobs/new')}
      rowRules={rowRules.job}
      menuOptions={modifiedMenuOptions}
      powerTableIndex={powerTableViewCode === 'overviewJobs' ? powerTableIndex : null}
      isSupplyWarningON={isSupplyWarningON}
      isTemplateWarningON={isTemplateWarningON}
      isSubmissionWarningON={isSubmissionWarningON}
      {...jobsData}
      {...rest}
    />
    <SummaryTable
      description={placeholderDescription('order', '/supplies/new')}
      rowRules={rowRules.order}
      menuOptions={modifiedMenuOptions}
      powerTableIndex={powerTableViewCode === 'overviewOrders' ? powerTableIndex : null}
      isSupplyWarningON={isSupplyWarningON}
      isTemplateWarningON={isTemplateWarningON}
      isSubmissionWarningON={isSubmissionWarningON}
      {...ordersData}
      {...rest}
    />
    <SummaryTable
      description={InvoiceDescription}
      rowRules={rowRules.invoice}
      menuOptions={modifiedMenuOptions}
      powerTableIndex={powerTableViewCode === 'overviewInvoices' ? powerTableIndex : null}
      {...invoicesData}
      {...rest}
    />
  </div>
)

};

OverviewDesktop.propTypes = {
  templatesData: PropTypes.shape({}),
  jobsData: PropTypes.shape({}),
  invoicesData: PropTypes.shape({}),
  ordersData: PropTypes.shape({}),
  placeholderDescription: PropTypes.func,
  InvoiceDescription: PropTypes.shape({}),
  rowRules: PropTypes.shape({}),
  menuOptions: PropTypes.arrayOf(PropTypes.shape({})),
  powerTableViewCode: PropTypes.string,
  powerTableIndex: PropTypes.number,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
};

export default OverviewDesktop;



// WEBPACK FOOTER //
// ./src/containers/Overview/OverviewDesktop/OverviewDesktop.jsx